module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dn3VD"))).then(() => parcelRequire('d0iPb'));